import { render, staticRenderFns } from "./Universe.vue?vue&type=template&id=04a6e2c4"
import script from "./Universe.vue?vue&type=script&lang=ts"
export * from "./Universe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports